var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"margin-x-auto",class:[_vm.data.fields.styleInstructions, _vm.getMediumWidth]},[_c(_vm.headingTag,{tag:"component",staticClass:"font-sans-xl text-center margin-bottom-2"},[_vm._v(" "+_vm._s(_vm.data.fields.subSectionHeading)+" ")]),_c('rich-text-renderer',{attrs:{"data":_vm.data.fields.subSectionBody}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }